import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useI18nLocalization } from '../../../i18nLocalization/useI18nLocalization';

const ConfirmDeleteModal = ({
	deleteModalIsVisible,
	onConfirmDeleteCallback,
	onCancelDeleteCallback,
	applicationName
}) => {
	const { t } = useI18nLocalization();
	const handleCancel = () => {
		onCancelDeleteCallback();
	};

	const handleDelete = () => {
		onConfirmDeleteCallback();
	};

	return (
		<>
			<Modal
				title={t(`Permanently Delete ${applicationName}?`)}
				centered
				visible={deleteModalIsVisible}
				onCancel={handleCancel}
				onOk={handleDelete}
			>
				{t('Are you sure you want to delete') + ' '}
				{applicationName}
				{'? ' + t('This action cannot be undone') + '.'}
			</Modal>
		</>
	);
};

ConfirmDeleteModal.propTypes = {
	deleteModalIsVisible: PropTypes.bool.isRequired,
	onConfirmDeleteCallback: PropTypes.func.isRequired,
	onCancelDeleteCallback: PropTypes.func.isRequired,
	applicationName: PropTypes.string.isRequired
};

export default ConfirmDeleteModal;
